import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons } from '@fluentui/react'

import Chat from './pages/chat/Chat'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage'
import { AppStateProvider } from './state/AppProvider'
import Unauthorized from './components/Auth/Unauthorized'
import { authService } from './services/auth'

import './index.css'

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/')

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [isAuthChecking, setIsAuthChecking] = useState<boolean>(true)

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        // const authenticated = await authService.attemptSilentSSO()
        // setIsAuthenticated(authenticated)
        setIsAuthenticated(true)
        setIsAuthChecking(false)
      } catch (error) {
        console.error('Error during authentication check:', error)
        setIsAuthChecking(false)
        setIsAuthenticated(false)
      }
    }

    checkAuthentication()
  }, [])

  if (isAuthChecking) {
    return <div className="auth-loading">Checking authentication...</div>
  }

  return (
    <AppStateProvider>
      <HashRouter>
        {isAuthenticated ? (
          <Routes>
            <Route path="/">
              <Route index element={<Chat />} />
              <Route path="*" element={<NoPage />} />
            </Route>
          </Routes>
        ) : (
          <Unauthorized />
        )}
      </HashRouter>
    </AppStateProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
